import React, { useEffect, useState } from 'react';
interface CountdownTimerProps {
  className?: string;
  variant?: 'light' | 'dark';
}
export function CountdownTimer({
  className = '',
  variant = 'light'
}: CountdownTimerProps) {
  const [time, setTime] = useState({
    hours: 23,
    minutes: 59,
    seconds: 59
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTime(prev => {
        if (prev.seconds > 0) {
          return {
            ...prev,
            seconds: prev.seconds - 1
          };
        } else if (prev.minutes > 0) {
          return {
            ...prev,
            minutes: prev.minutes - 1,
            seconds: 59
          };
        } else if (prev.hours > 0) {
          return {
            ...prev,
            hours: prev.hours - 1,
            minutes: 59,
            seconds: 59
          };
        } else {
          // Reset when reaches 0 to simulate perpetual urgency
          return {
            hours: 23,
            minutes: 59,
            seconds: 59
          };
        }
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const formatNumber = (num: number) => num.toString().padStart(2, '0');
  const boxClass = variant === 'light' ? 'bg-white text-blue-900 shadow-md' : 'bg-blue-900 text-white shadow-inner border border-blue-700';
  const labelClass = variant === 'light' ? 'text-blue-200' : 'text-blue-800';
  return <div className={`flex items-center gap-2 ${className}`} data-id="element-1">
      <div className="flex flex-col items-center" data-id="element-2">
        <div className={`${boxClass} rounded-lg p-2 min-w-[40px] text-center font-bold text-xl md:text-2xl`} data-id="element-3">
          {formatNumber(time.hours)}
        </div>
        <span className={`text-[10px] uppercase mt-1 font-bold ${labelClass}`} data-id="element-4">
          Hs
        </span>
      </div>
      <span className="text-xl font-bold -mt-4" data-id="element-5">:</span>
      <div className="flex flex-col items-center" data-id="element-6">
        <div className={`${boxClass} rounded-lg p-2 min-w-[40px] text-center font-bold text-xl md:text-2xl`} data-id="element-7">
          {formatNumber(time.minutes)}
        </div>
        <span className={`text-[10px] uppercase mt-1 font-bold ${labelClass}`} data-id="element-8">
          Min
        </span>
      </div>
      <span className="text-xl font-bold -mt-4" data-id="element-9">:</span>
      <div className="flex flex-col items-center" data-id="element-10">
        <div className={`${boxClass} rounded-lg p-2 min-w-[40px] text-center font-bold text-xl md:text-2xl`} data-id="element-11">
          {formatNumber(time.seconds)}
        </div>
        <span className={`text-[10px] uppercase mt-1 font-bold ${labelClass}`} data-id="element-12">
          Seg
        </span>
      </div>
    </div>;
}